export default function GlassCard({ className = "", children, ...props }) {
  return (
    <div {...props} className={`rounded-2xl border border-white dark:border-slate-900/60 bg-white dark:bg-slate-900/60 backdrop-blur-xl shadow-sm ${className}`}>
      {children}
    </div>
  );
}
